import { useState } from 'react'
import { Head, Link, router, usePage } from '@inertiajs/react'
import Layout from '../../components/Layout'
import { PersonSummary, ROLE_LABELS, UserRole } from '../../types'
import { sortPeople } from '../../utils/peopleSort'

interface Props {
  pending_users: PersonSummary[]
}

export default function PendingApprovals() {
  const { pending_users } = usePage().props as unknown as Props
  const [busyId, setBusyId] = useState<number | null>(null)

  const act = (id: number, action: 'approve' | 'deny') => {
    setBusyId(id)
    router.post(`/people/${id}/${action}`, {}, { onFinish: () => setBusyId(null) })
  }

  return (
    <Layout>
      <Head title="Pending approvals" />
      <div className="max-w-4xl mx-auto px-6 py-6">
        <div className="flex items-center gap-2 mb-2">
          <Link href="/people" className="text-sm text-text-muted hover:text-text-primary">&larr; People</Link>
        </div>
        <h1 className="text-2xl font-bold text-text-primary font-heading mb-1">Pending approvals</h1>
        <p className="text-sm text-text-secondary mb-6">
          New members can&rsquo;t sign in until you approve them.
        </p>

        <div className="bg-white rounded-xl border border-stone/20 shadow-sm overflow-hidden">
          {pending_users.length === 0 ? (
            <div className="px-6 py-12 text-center text-sm text-text-secondary">
              No one is waiting for approval.
            </div>
          ) : (
            sortPeople(pending_users).map(u => (
              <div key={u.id} className="flex items-center justify-between px-6 py-4 border-b border-stone/15 last:border-b-0">
                <div>
                  <p className="text-sm font-medium text-text-primary">{u.full_name}</p>
                  <p className="text-sm text-text-muted">{u.email}</p>
                  <p className="text-xs text-text-muted mt-0.5">
                    {ROLE_LABELS[u.role as UserRole] || u.role}
                    {u.manager_name && <> &middot; reports to {u.manager_name}</>}
                  </p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <button
                    onClick={() => act(u.id, 'deny')}
                    disabled={busyId === u.id}
                    className="px-3 py-1.5 text-sm font-medium text-[#ED1C24] border border-[#ED1C24]/30 rounded-lg hover:bg-[#ED1C24]/10 disabled:opacity-50"
                  >
                    Deny
                  </button>
                  <button
                    onClick={() => act(u.id, 'approve')}
                    disabled={busyId === u.id}
                    className="px-4 py-1.5 text-sm font-semibold text-white bg-pinnacle-red rounded-lg hover:bg-pinnacle-red/90 disabled:opacity-50"
                  >
                    Approve
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </Layout>
  )
}
